<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_tb_styleComponentAnimation()">
		<template v-if="$_tb_stateComponentIsInitialized">
			<v-app-bar
					class="customVAppBar"
					app
					fixed
					:clipped-left="!$_tb_stateComponentShowSettingNavigationDrawer"
					:color="$_tb_styleToolbarColor"
					:collapse-on-scroll="$_tb_styleToolbarCollapseOnScroll"
					:dark="$_tb_styleToolbarDark"
					:elevation="$_tb_styleToolbarElevation"
					:elevate-on-scroll="$_tb_styleToolbarElevateOnScroll"
					:flat="$_tb_styleToolbarFlat"
					:hide-on-scroll="$_tb_styleToolbarHideOnScroll"
					:inverted-scroll="$_tb_styleToolbarInvertedScroll"
					:light="$_tb_styleToolbarLight">
				<v-row align="center" no-gutters>
					<!-- Setting Menu -->
					<v-col cols="auto">
						<!-- (Mobile) -->
						<template v-if="$_tb_stateAppIsMobileScreen">
							<template v-if="$_tb_statePageName == 'menu'">
								<v-app-bar-nav-icon>
									<v-icon @click="$router.go(-1)">
										keyboard_arrow_left
									</v-icon>
								</v-app-bar-nav-icon>
							</template>
							<template v-else>
								<v-btn	class="customVBtn"
										icon
										to="/menu">
									<v-icon>menu</v-icon>
								</v-btn>
							</template>
						</template>
						<!-- (Web) -->
						<template v-else>
							<v-btn	class="customVBtn"
									icon
									@click="$_tb_toggleNavigationDrawer()">
								<v-icon>menu</v-icon>
							</v-btn>
						</template>
					</v-col>
					<!-- App Icon -->
					<v-col cols="auto">
						<template v-if="isObject($_tb_styleLogoImage)">
							<v-img	class="img_"
									contain 
									:src="$_tb_styleLogoImageUrl">
							</v-img>
						</template>
					</v-col>
					<!-- App Title -->
					<v-col lg="3">
						<v-toolbar-title>
							<router-link
									class="title_"
									:to="$_tb_linkTitle()">
								<template v-if="isEmpty($_tb_langTitle)">
									<span	class="title"
											:style="$_tb_styleTitleStyle"
											v-html="appName" />
								</template>
								<template v-else>
									<span	class="title"
											:style="$_tb_styleTitleStyle"
											v-html="$_tb_langTitle" />
								</template>
							</router-link>
						</v-toolbar-title>
					</v-col>
					<template v-if="!$_tb_stateAppIsMobileScreen">
						<!-- Toolbar Menu -->
						<v-col>
							<template v-if="!$_tb_infoPageHideToolbarMenu()">
								<v-sheet class="sheet_" color="transparent">
									<v-slide-group show-arrows>
										<v-row no-gutters align="center">
											<v-spacer />
											<!-- custom bri life start -->
											<!--
											<tepmlate v-if="$_tb_statePageName == 'point' && ($_tb_currentUserUid() == 'admin' || $_tb_stateUserSecurityGroupCode() == 'adminibs' || $_tb_stateUserSecurityGroupCode() == 'ibs')">
												<custom-bri-life-lottery-dialog />
											</tepmlate>
											-->
											<!-- custom bri life end -->
											<!-- App Menu Items -->
											<!-- (order = until 50) -->
											<template v-for="(menuItemVals, menuItemKey) in sortObject($_tb_appMenuItemsContentsIsToolbarMenu, 'order')">
												<template v-if="menuItemVals.order <= 50">
													<template v-if="checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
														<v-col	class="py-0"
																:key="menuItemKey"
																cols="auto">
															<app-menu-slide-item
																	:contentKey="menuItemKey"
																	:contents="$_tb_appMenuItemsContentsIsToolbarMenu"
																	:inits="$_tb_appMenuItemsInits" />
														</v-col>
													</template>
												</template>
											</template>
											<!-- Toolbar Menu -->
											<!-- (order = until 50) -->
											<template v-for="(contentVals, contentKey) in sortObject($_tb_contents(), 'order')">
												<template v-if="contentVals.order <= 50">
													<!-- Collapsed Menu -->
													<template v-if="contentVals.isCollapsedMenu">
														<template v-if="checkMenuGroup(contentVals.menuGroup) && checkSecurityGroup(contentVals.securityGroup)">
															<v-col	class="py-0"
																	:key="contentKey"
																	cols="auto">
																<collapsed-menu-slide-item 
																		:contentKey="contentKey"
																		:contents="$_tb_contents()"
																		:inits="$_tb_inits()" />
															</v-col>
														</template>
													</template>
													<!-- Tab Menu -->
													<template v-if="contentVals.isTabMenu">
														<template v-if="checkMenuGroup(contentVals.menuGroup) && checkSecurityGroup(contentVals.securityGroup)">
															<v-col	class="py-0"
																	:key="contentKey"
																	cols="auto">
																<tab-menu-slide-item 
																		:contentKey="contentKey"
																		:contents="$_tb_contents()"
																		:inits="$_tb_inits()" />
															</v-col>
														</template>
													</template>
												</template>
											</template>
											<!-- App Menu Items -->
											<!-- (order = 51 - 100) -->
											<template v-for="(menuItemVals, menuItemKey) in sortObject($_tb_appMenuItemsContentsIsToolbarMenu, 'order')">
												<template v-if="menuItemVals.order > 50 && menuItemVals.order <= 100">
													<template v-if="checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
														<v-col	class="py-0"
																:key="menuItemKey"
																cols="auto">
															<app-menu-slide-item
																	:contentKey="menuItemKey"
																	:contents="$_tb_appMenuItemsContentsIsToolbarMenu"
																	:inits="$_tb_appMenuItemsInits" />
														</v-col>
													</template>
												</template>
											</template>
											<!-- Toolbar Menu -->
											<!-- (order = over 50) -->
											<template v-for="(contentVals, contentKey) in sortObject($_tb_contents(), 'order')">
												<template v-if="contentVals.order > 50">
													<!-- Collapsed Menu -->
													<template v-if="contentVals.isCollapsedMenu">
														<template v-if="checkMenuGroup(contentVals.menuGroup) && checkSecurityGroup(contentVals.securityGroup)">
															<v-col	class="py-0"
																	:key="contentKey"
																	cols="auto">
																<collapsed-menu-slide-item 
																		:contentKey="contentKey"
																		:contents="$_tb_contents()"
																		:inits="$_tb_inits()" />
															</v-col>
														</template>
													</template>
													<!-- Tab Menu -->
													<template v-if="contentVals.isTabMenu">
														<template v-if="checkMenuGroup(contentVals.menuGroup) && checkSecurityGroup(contentVals.securityGroup)">
															<v-col	class="py-0"
																	:key="contentKey"
																	cols="auto">
																<tab-menu-slide-item 
																		:contentKey="contentKey"
																		:contents="$_tb_contents()"
																		:inits="$_tb_inits()" />
															</v-col>
														</template>
													</template>
												</template>
											</template>
											<!-- App Menu -->
											<!-- (order = over 100) -->
											<template v-for="(menuItemVals, menuItemKey) in sortObject($_tb_appMenuItemsContentsIsToolbarMenu, 'order')">
												<template v-if="menuItemVals.order > 100">
													<template v-if="checkMenuGroup(menuItemVals.menuGroup) && checkSecurityGroup(menuItemVals.securityGroup)">
														<v-col	class="py-0"
																:key="menuItemKey"
																cols="auto">
															<app-menu-slide-item
																	:contentKey="menuItemKey"
																	:contents="$_tb_appMenuItemsContentsIsToolbarMenu"
																	:inits="$_tb_appMenuItemsInits" />
														</v-col>
													</template>
												</template>
											</template>
										</v-row>
									</v-slide-group>
								</v-sheet>
							</template>
						</v-col>
						<!-- User Menu -->
						<v-col cols="auto">
							<user-menu-slide-item
									:contents="$_tb_contents()"
									:inits="$_tb_inits()" />
						</v-col>
						<!-- Contact -->
						<template v-if="!isEmpty($_tb_infoPageContact)">
							<v-col cols="auto">
								<v-btn	class="customVBtn mr-2 px-2"

										icon

										:block="$_tb_styleMenuButtonBlock"
										:color="$_tb_styleMenuButtonColor"
										:dark="$_tb_styleMenuButtonDark"
										:depressed="$_tb_styleMenuButtonDepressed"
										:elevation="$_tb_styleMenuButtonElevation"
										:large="$_tb_styleMenuButtonLarge"
										:light="$_tb_styleMenuButtonLight"
										:outlined="$_tb_styleMenuButtonOutlined"
										:rounded="$_tb_styleMenuButtonRounded"
										:small="$_tb_styleMenuButtonSmall"
										:text="$_tb_styleMenuButtonFlat"
										@click="$_tb_toggleMessagebarFooter()">
									<v-icon>chat</v-icon>
								</v-btn>
							</v-col>
						</template>
						<!-- developer menu -->
						<template v-if="debugMode">
							<v-col cols="auto">
								<debugger-firebase-alert />
							</v-col>
							<v-col cols="auto">
								<v-menu offset-y>
									<template v-slot:activator="{ on }">
										<v-btn	class="customVBtn"
												color="error"
												icon
												v-on="on">
											<v-icon>apps</v-icon>
										</v-btn>
									</template>
									<v-btn-toggle class="debugger_" group>
										<debugger-dialog />
										<debugger-button />
									</v-btn-toggle>
								</v-menu>
							</v-col>
						</template>
						<!-- builder menu -->
						<template v-if="buildMode">
							<v-col cols="auto">
								<v-menu offset-y>
									<template v-slot:activator="{ on }">
										<v-btn	class="customVBtn"
												color="success"
												icon
												v-on="on">
											<v-icon>apps</v-icon>
										</v-btn>
									</template>
									<v-btn-toggle class="builder_" group>
										<template v-if="$_tb_stateAppMenuGroup == 'training'">
											<builder-training-dialog />
										</template>	
										<builder-app-dialog />
										<builder-component-dialog />
										<builder-page-dialog />
										<builder-other-dialog />
										<builder-file-input />
										<builder-preview-slide-item />
									</v-btn-toggle>
								</v-menu>
							</v-col>
						</template>
					</template>
				</v-row>
				<!-- fab -->
				<template v-if="$_tb_stateAppIsMobileScreen">
					<v-fab-transition>
						<template v-if="$_tb_currentUser()">
							<template v-if="!isEmpty($_tb_infoPageContactUid)">
								<v-btn	class="customVBtn fab_"
										absolute 
										bottom 
										fab 
										right
										@click="$_tb_toggleMessagebarFooter()">
									<v-icon>chat</v-icon>
								</v-btn>
							</template>
						</template>
						<template v-else>
							<template v-if="$_tb_statePageName != 'login' && $_tb_statePageName != 'signUp'">
								<v-btn	class="customVBtn fab_"
										absolute 
										bottom 
										fab 
										right
										to="/login">
									<v-icon>account_circle</v-icon>
								</v-btn>
							</template>
						</template>
					</v-fab-transition>
				</template>
			</v-app-bar>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Toolbar',
		data() {
			return {
				componentName_: 'toolbar'
			}
		},
		computed: {
			// custom bri life start
			$_tb_stateUserSecurityGroupCode() {
				const self_ = this;
				return () => {
					return self_.getUserState('securityGroupCode')
				}
			},
			// custom bri life end
			// current user
			$_tb_currentUser() {
				const self_ = this;
				return () => {
					return self_.getCurrentUser()
				}
			},
			$_tb_currentUserUid() {
				const self_ = this;
				return () => {
					return self_.getCurrentUser('uid')
				}
			},
			// state
			$_tb_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_tb_stateAppMenuGroup() {
				const self_ = this;
				return self_.getAppState('menuGroup')
			},
			$_tb_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_tb_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			},
			$_tb_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			$_tb_stateComponentShowMessagebarFooter() {
				const self_ = this;
				return self_.getComponentState('showMessagebarFooter')
			},
			$_tb_stateComponentShowSettingNavigationDrawer() {
				const self_ = this;
				return self_.getComponentState('showSettingNavigationDrawer')
			},
			// page info
			$_tb_pageInits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.$_tb_statePageName)
				}
			},
			$_tb_infoPageHideToolbarMenu() {
				const self_ = this;
				return () => {
					return self_.getInitsInfoVal(self_.$_tb_pageInits(), 'hideToolbarMenu')
				}
			},
			$_tb_infoPageHidePageContents() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_tb_pageInits(), 'hidePageContents')
			},
			$_tb_infoPageShowPageTitle() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_tb_pageInits(), 'showPageTitle')
			},
			$_tb_infoPageContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_tb_pageInits(), 'contact')
			},
			$_tb_infoPageContactUid() {
				const self_ = this;
				const contact_ = self_.$_tb_infoPageContact;
				if(self_.isFalse(contact_)) { return null }
				return contact_.uid
			},
			$_tb_infoPageContactName() {
				const self_ = this;
				const contact_ = self_.$_tb_infoPageContact;
				if(self_.isFalse(contact_)) { return null }
				return contact_.name
			},
			// app menu
			$_tb_appMenuItemsContents() {
				const self_ = this;
				const contents_ = self_.getAppContents('menuItems')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			$_tb_appMenuItemsInits() {
				const self_ = this;
				return self_.getAppInits('menuItems')
			},
			$_tb_appMenuItemsContentsIsCollapsedMenu() {
				const self_ = this;
				const menuItems_ = self_.$_tb_appMenuItemsContents;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isCollapsedMenu', true)
			},
			$_tb_appMenuItemsContentsIsTabMenu() {
				const self_ = this;
				const menuItems_ = self_.$_tb_appMenuItemsContents;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isTabMenu', true)
			},
			$_tb_appMenuItemsContentsIsToolbarMenu() {
				const self_ = this;
				const menuItems_ = self_.$_tb_appMenuItemsContents;
				if(self_.isEmpty(menuItems_)) { return null }
				return self_.getContentsSubset(menuItems_, 'isToolbarMenu', true)
			},
			// contents / inits
			$_tb_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_tb_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_tb_langTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tb_inits(), 'title')
				return self_.getLangsVal(lang_)
			},
			$_tb_langContactUsButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tb_inits(), 'contactUsButtonTitle')
				return self_.getLangsVal(lang_)
			},
			$_tb_langLoginButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tb_inits(), 'loginButtonTitle')
				return self_.getLangsVal(lang_)
			},
			$_tb_langProfileButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tb_inits(), 'profileButtonTitle')
				return self_.getLangsVal(lang_)
			},
			$_tb_langTimelineButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tb_inits(), 'timelineButtonTitle')
				return self_.getLangsVal(lang_)
			},
			$_tb_langLogoutButtonTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_tb_inits(), 'logoutButtonTitle')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_tb_langContentTitle() {
				const self_ = this;
				return menuItemVals => {
					const title_ = menuItemVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}				
			},
			// link
			$_tb_linkTitle() {
				const self_ = this;

				return () => {
					const menuGroup_ = self_.$_tb_stateAppMenuGroup;

					const link_ = self_.getInitsLinkVal(self_.$_tb_inits(), 'title')

					// menu group
					if(self_.isObject(link_.to)) { 
						if(!self_.isFalse(link_.to[menuGroup_])) { return link_.to[menuGroup_] }
						else { return link_.to }
					// to
					} else { return link_.to }
				}
			},
			// style
			$_tb_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_tb_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_tb_inits(), 'component')
				}
			},
			$_tb_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_tb_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_tb_styleTitle() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tb_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tb_inits(), 'title')
			},
			$_tb_styleTitleStyle() {
				const self_ = this;
				const style_ = self_.$_tb_styleTitle;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.style)
			},
			$_tb_styleToolbar() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tb_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tb_inits(), 'toolbar')
			},
			$_tb_styleToolbarColor() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.color)
			},
			$_tb_styleToolbarCollapseOnScroll() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.collapseOnScroll)
			},
			$_tb_styleToolbarDark() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.dark)
			},
			$_tb_styleToolbarElevation() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.elevation)
			},
			$_tb_styleToolbarElevateOnScroll() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.elevateOnScroll)
			},
			$_tb_styleToolbarFlat() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.flat)
			},
			$_tb_styleToolbarHideOnScroll() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.hideOnScroll)
			},
			$_tb_styleToolbarInvertedScroll() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.invertedScroll)
			},
			$_tb_styleToolbarLight() {
				const self_ = this;
				const toolbar_ = self_.$_tb_styleToolbar;
				if(self_.isFalse(toolbar_)) { return null }
				return self_.getStylesVal(toolbar_.light)
			},
			$_tb_styleMenuButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tb_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tb_inits(), 'menuButton')
			},
			$_tb_styleMenuButtonBlock() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_tb_styleMenuButtonColor() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_tb_styleMenuButtonDark() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_tb_styleMenuButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_tb_styleMenuButtonElevation() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_tb_styleMenuButtonLarge() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_tb_styleMenuButtonLight() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_tb_styleMenuButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_tb_styleMenuButtonRounded() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_tb_styleMenuButtonSmall() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_tb_styleMenuButtonFlat() {
				const self_ = this;
				const button_ = self_.$_tb_styleMenuButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_tb_styleCollapsedMenu() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tb_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tb_inits(), 'collapsedMenu')
			},
			$_tb_styleCollapsedMenuDark() {
				const self_ = this;
				const menu_ = self_.$_tb_styleCollapsedMenu;
				if(self_.isFalse(menu_)) { return null }
				return self_.getStylesVal(menu_.dark)
			},
			$_tb_styleCollapsedMenuLight() {
				const self_ = this;
				const menu_ = self_.$_tb_styleCollapsedMenu;
				if(self_.isFalse(menu_)) { return null }
				return self_.getStylesVal(menu_.light)
			},
			$_tb_styleLogoImage() {
				const self_ = this;
				if(self_.isEmpty(self_.$_tb_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_tb_inits(), 'logoImage')
			},
			$_tb_styleLogoImageUrl() {
				const self_ = this;
				const image_ =self_.$_tb_styleLogoImage;
				if(self_.isFalse(image_)) { return null }
				return self_.getStylesVal(image_.url)
			}
		},
		methods: {
			$_tb_toggleMessagebarFooter() {
				const self_ = this;
				const router_ = self_.$router;

				// not logged in
				if(self_.isEmpty(self_.$_tb_currentUser())) {
					router_.push('/login')
				}
				// already logged in
				else {
					if(self_.$_tb_stateComponentShowMessagebarFooter) {
						self_.setComponentState('showMessagebarFooter', false)
						// reset message state
						self_.resetMessageState()
					} else {
						self_.setMessageState('toUid', self_.$_tb_infoPageContactUid)
						self_.setMessageState('toName',	self_.$_tb_infoPageContactName)

						self_.setMessageState('pageName', self_.$_tb_statePageName)	
						self_.setMessageState('pageType', self_.$_tb_statePageType)	
						
						self_.setComponentState('showMessagebarFooter', true)
					}
				}
			},
			$_tb_toggleNavigationDrawer() {
				const self_ = this;
				let show_ = self_.getComponentState('showSettingNavigationDrawer')
				self_.setComponentState('showSettingNavigationDrawer', !show_)
			}
		}
	}
</script>

<style scoped>
	.title_ {
		text-decoration: none !important;
		margin-right: 20px !important;
	}
	.sheet_ {
		width: 100% !important;
	}
	.fab_ {
		margin-right: 16px !important;
	}
	@media screen and (min-width:960px) {
		.img_ {
			max-height: 36px !important;
			max-width: 36px !important;
			margin-right: 16px !important;
		}
	}
	@media screen and (max-width:959px) {
		.img_ {
			max-height: 24px !important;
			max-width: 24px !important;
			margin-right: 12px !important;
		}
	}
	.row_ {
		flex: 0 0 auto !important;
	}
	.button_ {
		width: 100% !important;
		text-align: left !important;
	}
	.v-menu__content {
		max-width: 80% !important;
	}
	.builder_ {
		background-color: #4CAF50 !important;
	}
	.debugger_ {
		background-color: #FF5252 !important;
	}
</style>
